import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type AvatarProps = WithClassName<{
	name?: string
	indicator?: boolean
}>

const getInitials = (name = '') => {
	const words = name
		.split('@')[0]
		.split(/[\s._-]+/)
		.filter(Boolean)

	if (!words.length) return ''
	if (words.length === 1) return words[0].charAt(0).toUpperCase()

	return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase()
}

export const Avatar = ({ name, indicator = false, className }: AvatarProps) => (
	<span
		aria-hidden
		className={cn(
			'relative grid h-8 w-8 shrink-0 place-items-center rounded-full bg-muted font-display text-[11px] font-bold text-primary',
			className
		)}>
		{getInitials(name)}
		{indicator && (
			<span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full border-2 border-card bg-danger" />
		)}
	</span>
)
